import { ProjectAge } from '../ProjectAge'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'next-i18next'
import { Project } from '@/interfaces/projects'
import { ProjectStatsList } from '@/components/projects/ProjectStatsList'

interface ProjectCardFooterProps {
  project: Project
}

const ProjectCardFooterStyled = styled(CardContent)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey['200']}`,
  display: 'flex',
  marginTop: 'auto',
  alignItems: 'center',
  '& > :last-child': {
    marginLeft: 'auto'
  },
  '&:last-child': {
    paddingBottom: 10
  }
}))

export const ProjectCardFooter = ({ project }: ProjectCardFooterProps): React.ReactElement => {
  const { t } = useTranslation('projects')

  return (
    <ProjectCardFooterStyled>
      <ProjectAge date={project.creationDate} title={t('created')} overflow="hidden" textOverflow="ellipsis" />
      <ProjectStatsList
        numberOfViews={project.numberOfViews}
        numberOfCopies={project.numberOfCopies}
        numberOfSimulationRuns={project.numberOfSimulationRuns}
      />
    </ProjectCardFooterStyled>
  )
}
